var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWaste1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 195,
    height: 170,
    viewBox: "0 0 195 170",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2651_13823)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M156.735 82.2127V72.2244H153.513V55.0501H136.234V72.2244H120.079V48.6836L102.252 42.3354V62.406H98.1873V35.6777L80.3606 41.2361V81.3821H57.8153V105.095H49.3915V111.069H30.0422V100.782H18.933V72.8298H5.20971V124.429H-8.51343V169.329H5.20971H16.9725H18.933H30.0422H36.3217H46.3794H49.3915H57.8153H65.7287H80.3606H84.8417H93.7569H98.1873H102.252H111.584H117.936H120.079H136.234H153.224H153.513H156.735H170.503V82.2127H156.735Z",
    fill: "#69ABB9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.0499 43.2695H83.0244V47.4129H95.0499V43.2695Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.0501 51.0518H83.0247V55.1951H95.0501V51.0518Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.0499 58.0557H83.0244V62.199H95.0499V58.0557Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1871 91.6621H5.20972V98.0576H19.1871V91.6621Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0533 111.294H5.20947V117.689H19.0533V111.294Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0533 120.955H5.20947V127.351H19.0533V120.955Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8279 131.062H4.98413V137.457H18.8279V131.062Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8279 140.96H4.98413V147.355H18.8279V140.96Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8277 151.068H4.98389V157.464H18.8277V151.068Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.248 58.0557H104.6V62.199H117.248V58.0557Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.248 51.1162H104.6V55.2595H117.248V51.1162Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.248 66.1123H82.7185V70.2557H117.248V66.1123Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.248 72.3428H82.7185V76.4861H117.248V72.3428Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.248 78.5303H82.7185V82.5149H117.248V78.5303Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0535 101.634H5.20972V108.029H19.0535V101.634Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.2893 85.2686H61.2673V89.2762H64.2893V85.2686Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.9405 85.2686H66.9185V89.2762H69.9405V85.2686Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.4653 85.2686H72.4434V89.2762H75.4653V85.2686Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.7032 85.2686H77.6812V89.2762H80.7032V85.2686Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.0421 85.2686H83.02V89.2762H86.0421V85.2686Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.4422 85.2686H88.4202V89.2762H91.4422V85.2686Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.0932 85.2686H94.0713V89.2762H97.0932V85.2686Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.618 85.2686H99.5962V89.2762H102.618V85.2686Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.856 85.2686H104.834V89.2762H107.856V85.2686Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.195 85.2686H110.173V89.2762H113.195V85.2686Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.759 85.2686H115.737V89.2762H118.759V85.2686Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.41 85.2686H121.388V89.2762H124.41V85.2686Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.935 85.2686H126.913V89.2762H129.935V85.2686Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.173 85.2686H132.151V89.2762H135.173V85.2686Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.512 85.2686H137.49V89.2762H140.512V85.2686Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.563 85.2686H148.541V89.2762H151.563V85.2686Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.088 85.2686H154.066V89.2762H157.088V85.2686Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.326 85.2686H159.304V89.2762H162.326V85.2686Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.665 85.2686H164.643V89.2762H167.665V85.2686Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.2893 92.3408H61.2673V96.3485H64.2893V92.3408Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.9407 92.3408H66.9187V96.3485H69.9407V92.3408Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.4653 92.3408H72.4434V96.3485H75.4653V92.3408Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.7032 92.3408H77.6812V96.3485H80.7032V92.3408Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.0421 92.3408H83.02V96.3485H86.0421V92.3408Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.4422 92.3408H88.4202V96.3485H91.4422V92.3408Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.0935 92.3408H94.0715V96.3485H97.0935V92.3408Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.618 92.3408H99.5959V96.3485H102.618V92.3408Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.856 92.3408H104.834V96.3485H107.856V92.3408Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.195 92.3408H110.173V96.3485H113.195V92.3408Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.759 92.3408H115.737V96.3485H118.759V92.3408Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.41 92.3408H121.388V96.3485H124.41V92.3408Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.935 92.3408H126.913V96.3485H129.935V92.3408Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.173 92.3408H132.151V96.3485H135.173V92.3408Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.512 92.3408H137.49V96.3485H140.512V92.3408Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.912 92.3408H142.89V96.3485H145.912V92.3408Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.563 92.3408H148.541V96.3485H151.563V92.3408Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.088 92.3408H154.066V96.3485H157.088V92.3408Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.326 92.3408H159.304V96.3485H162.326V92.3408Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.665 92.3408H164.643V96.3485H167.665V92.3408Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.2893 99.3037H61.2673V103.311H64.2893V99.3037Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.9407 99.3037H66.9187V103.311H69.9407V99.3037Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.4653 99.3037H72.4434V103.311H75.4653V99.3037Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.7032 99.3037H77.6812V103.311H80.7032V99.3037Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.0421 99.3037H83.02V103.311H86.0421V99.3037Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.4422 99.3037H88.4202V103.311H91.4422V99.3037Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.0932 99.3037H94.0713V103.311H97.0932V99.3037Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.618 99.3037H99.5959V103.311H102.618V99.3037Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.856 99.3037H104.834V103.311H107.856V99.3037Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.195 99.3037H110.173V103.311H113.195V99.3037Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.759 99.3037H115.737V103.311H118.759V99.3037Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.41 99.3037H121.388V103.311H124.41V99.3037Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.935 99.3037H126.913V103.311H129.935V99.3037Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.173 99.3037H132.151V103.311H135.173V99.3037Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.512 99.3037H137.49V103.311H140.512V99.3037Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.912 99.3037H142.89V103.311H145.912V99.3037Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.563 99.3037H148.541V103.311H151.563V99.3037Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.088 99.3037H154.066V103.311H157.088V99.3037Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.326 99.3037H159.304V103.311H162.326V99.3037Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.665 99.3037H164.643V103.311H167.665V99.3037Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.2893 106.702H61.2673V110.71H64.2893V106.702Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.9407 106.702H66.9187V110.71H69.9407V106.702Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.4653 106.702H72.4434V110.71H75.4653V106.702Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.7032 106.702H77.6812V110.71H80.7032V106.702Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.0421 106.702H83.02V110.71H86.0421V106.702Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.4422 106.702H88.4202V110.71H91.4422V106.702Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.0932 106.702H94.0713V110.71H97.0932V106.702Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.618 106.702H99.5959V110.71H102.618V106.702Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.856 106.702H104.834V110.71H107.856V106.702Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.195 106.702H110.173V110.71H113.195V106.702Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.759 106.702H115.737V110.71H118.759V106.702Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.41 106.702H121.388V110.71H124.41V106.702Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.935 106.702H126.913V110.71H129.935V106.702Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.173 106.702H132.151V110.71H135.173V106.702Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.512 106.702H137.49V110.71H140.512V106.702Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.912 106.702H142.89V110.71H145.912V106.702Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.563 106.702H148.541V110.71H151.563V106.702Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.088 106.702H154.066V110.71H157.088V106.702Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.326 106.702H159.304V110.71H162.326V106.702Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.665 106.702H164.643V110.71H167.665V106.702Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.2893 113.774H61.2673V117.782H64.2893V113.774Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.9407 113.774H66.9187V117.782H69.9407V113.774Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.4653 113.774H72.4434V117.782H75.4653V113.774Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.7032 113.774H77.6812V117.782H80.7032V113.774Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.0421 113.774H83.02V117.782H86.0421V113.774Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.4422 113.774H88.4202V117.782H91.4422V113.774Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.0935 113.774H94.0715V117.782H97.0935V113.774Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.618 113.774H99.5959V117.782H102.618V113.774Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.856 113.774H104.834V117.782H107.856V113.774Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.195 113.774H110.173V117.782H113.195V113.774Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.759 113.774H115.737V117.782H118.759V113.774Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.41 113.774H121.388V117.782H124.41V113.774Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.935 113.774H126.913V117.782H129.935V113.774Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.173 113.774H132.151V117.782H135.173V113.774Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.512 113.774H137.49V117.782H140.512V113.774Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.912 113.774H142.89V117.782H145.912V113.774Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.563 113.774H148.541V117.782H151.563V113.774Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.326 113.774H159.304V117.782H162.326V113.774Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.088 113.774H154.066V117.782H157.088V113.774Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.665 113.774H164.643V117.782H167.665V113.774Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.2893 120.738H61.2673V124.746H64.2893V120.738Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.9407 120.738H66.9187V124.746H69.9407V120.738Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.4653 120.738H72.4434V124.746H75.4653V120.738Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.7032 120.738H77.6812V124.746H80.7032V120.738Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.0421 120.738H83.02V124.746H86.0421V120.738Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.4422 120.738H88.4202V124.746H91.4422V120.738Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.0932 120.738H94.0713V124.746H97.0932V120.738Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.618 120.738H99.5959V124.746H102.618V120.738Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.856 120.738H104.834V124.746H107.856V120.738Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.195 120.738H110.173V124.746H113.195V120.738Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.759 120.738H115.737V124.746H118.759V120.738Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.41 120.738H121.388V124.746H124.41V120.738Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.935 120.738H126.913V124.746H129.935V120.738Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.173 120.738H132.151V124.746H135.173V120.738Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.512 120.738H137.49V124.746H140.512V120.738Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.912 120.738H142.89V124.746H145.912V120.738Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.563 120.738H148.541V124.746H151.563V120.738Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.326 120.738H159.304V124.746H162.326V120.738Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.665 120.738H164.643V124.746H167.665V120.738Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.721 112.815H192.998V155.609H199.721V112.815Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.998 138.834H185.781V168.558H192.998V138.834Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.9578 100.765V92.4287H35.322V100.765H40.3079V111.051H30.0403V100.765H34.9578Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.20972 79.2376V72.842H8.09859V70.0586H8.46258V72.842H18.9949H19.1871H21.1794V70.0586H21.5434V72.842H24.0991V100.791H18.9949V88.7488H5.20972V82.3534H18.9949V79.2376H5.20972Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.448 119.044V155.118H192.998V112.815L154.448 119.044Z",
    fill: "#69ABB9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.541 138.723H154.448V169.153H202.541V138.723Z",
    fill: "#69ABB9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.541 120.713H154.448V130.603H202.541V120.713Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.192 146.972H157.722V150.247H160.192V146.972Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.811 146.972H162.341V150.247H164.811V146.972Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.327 146.972H166.856V150.247H169.327V146.972Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.608 146.972H171.138V150.247H173.608V146.972Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.971 146.972H175.501V150.247H177.971V146.972Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.385 146.972H179.915V150.247H182.385V146.972Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.004 146.972H184.534V150.247H187.004V146.972Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.519 146.972H189.049V150.247H191.519V146.972Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.801 146.972H193.331V150.247H195.801V146.972Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.192 152.751H157.722V156.026H160.192V152.751Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.811 152.751H162.341V156.026H164.811V152.751Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.327 152.751H166.856V156.026H169.327V152.751Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.608 152.751H171.138V156.026H173.608V152.751Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.971 152.751H175.501V156.026H177.971V152.751Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.385 152.751H179.915V156.026H182.385V152.751Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.004 152.751H184.534V156.026H187.004V152.751Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.519 152.751H189.049V156.026H191.519V152.751Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.801 152.751H193.331V156.026H195.801V152.751Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.192 135.324H157.722V138.6H160.192V135.324Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.811 135.324H162.341V138.6H164.811V135.324Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.327 135.324H166.856V138.6H169.327V135.324Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.608 135.324H171.138V138.6H173.608V135.324Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.971 135.324H175.501V138.6H177.971V135.324Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.385 135.324H179.915V138.6H182.385V135.324Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.004 135.324H184.534V138.6H187.004V135.324Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.519 135.324H189.049V138.6H191.519V135.324Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.192 141.104H157.722V144.379H160.192V141.104Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.811 141.104H162.341V144.379H164.811V141.104Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.327 141.104H166.856V144.379H169.327V141.104Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.608 141.104H171.138V144.379H173.608V141.104Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.971 141.104H175.501V144.379H177.971V141.104Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.385 141.104H179.915V144.379H182.385V141.104Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.004 141.104H184.534V144.379H187.004V141.104Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.519 141.104H189.049V144.379H191.519V141.104Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.801 141.104H193.331V144.379H195.801V141.104Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.192 158.444H157.722V161.72H160.192V158.444Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.811 158.444H162.341V161.72H164.811V158.444Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.327 158.444H166.856V161.72H169.327V158.444Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.608 158.444H171.138V161.72H173.608V158.444Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.971 158.444H175.501V161.72H177.971V158.444Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.385 158.444H179.915V161.72H182.385V158.444Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.004 158.444H184.534V161.72H187.004V158.444Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.519 158.444H189.049V161.72H191.519V158.444Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.801 158.444H193.331V161.72H195.801V158.444Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.192 163.512H157.722V166.787H160.192V163.512Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.811 163.512H162.341V166.787H164.811V163.512Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.327 163.512H166.856V166.787H169.327V163.512Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.608 163.512H171.138V166.787H173.608V163.512Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.971 163.512H175.501V166.787H177.971V163.512Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.385 163.512H179.915V166.787H182.385V163.512Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.004 163.512H184.534V166.787H187.004V163.512Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.519 163.512H189.049V166.787H191.519V163.512Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.801 163.512H193.331V166.787H195.801V163.512Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.413 106.023H189.7V114.6H190.413V106.023Z",
    fill: "#69ABB9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.192 123.491H158.116V126.87H160.192V123.491Z",
    fill: "#69ABB9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.798 123.491H178.722V126.87H180.798V123.491Z",
    fill: "#69ABB9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.8524 169.152H97.064V131.062H27.8524V169.152Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.6958 132.801H37.2532V120.954L51.6958 126.156V132.801Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.877 169.153H155.929V135.327L122.877 146.092V169.153Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.75 148.258H155.056V147.213H123.75V148.258Z",
    fill: "#69ABB9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.75 151.615H155.056V150.57H123.75V151.615Z",
    fill: "#69ABB9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.75 154.977H155.056V153.931H123.75V154.977Z",
    fill: "#69ABB9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.75 158.334H155.056V157.289H123.75V158.334Z",
    fill: "#69ABB9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.75 161.696H155.056V160.651H123.75V161.696Z",
    fill: "#69ABB9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.75 165.056H155.056V164.01H123.75V165.056Z",
    fill: "#69ABB9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.476 131.062H37.2534V120.955H34.476V131.062Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.058 71.75H152.973V56.4631H151.058V71.75Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.249 71.75H149.164V56.4631H147.249V71.75Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.491 71.75H145.406V56.4631H143.491V71.75Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.602 71.75H141.518V56.4631H139.602V71.75Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.5125 51.0018H45.0972L45.1096 50.9088L45.5367 47.749C45.5511 47.6473 45.6534 47.5703 45.7761 47.5703C45.7915 47.5703 45.8058 47.5711 45.8213 47.5728C45.9007 47.5808 45.9735 47.6097 46.031 47.6529C46.0982 47.7043 46.1431 47.7756 46.1526 47.8566L46.5125 51.0018Z",
    fill: "#BAD8DF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.2338 50.285L45.1833 50.286L45.5367 47.749C45.5512 47.6473 45.6535 47.5703 45.7762 47.5703C45.7916 47.5703 45.8059 47.5711 45.8213 47.5728C45.8346 47.5823 45.8472 47.592 45.8587 47.6025C45.921 47.6586 45.9583 47.7323 45.9593 47.8141L45.98 49.6382C45.9836 49.988 45.6516 50.2758 45.2338 50.285Z",
    fill: "#BAD8DF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.4145 65.0625H44.6853V165.931H47.4145V65.0625Z",
    fill: "#BAD8DF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.9456 65.0625H44.6853V165.931H45.9456V65.0625Z",
    fill: "#BAD8DF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.3956 149.834H41.7031V176.691H50.3956V149.834Z",
    fill: "#BAD8DF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.8841 149.834H41.7031V176.691H46.8841V149.834Z",
    fill: "#BAD8DF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.7997 52.5233C50.7997 53.7697 48.5636 54.7797 45.8047 54.7797C45.5939 54.7797 45.387 54.7741 45.1832 54.7621C42.7183 54.6243 40.8096 53.6743 40.8096 52.5233C40.8096 51.3722 42.7183 50.4231 45.1832 50.2852C45.3872 50.2732 45.5939 50.2676 45.8047 50.2676C48.5636 50.2677 50.7997 51.2777 50.7997 52.5233Z",
    fill: "#BAD8DF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.3854 67.0518H41.6934L38.6289 54.7002H52.9809L50.3854 67.0518Z",
    fill: "#BAD8DF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.7559 53.7705H37.8533V54.9553H53.7559V53.7705Z",
    fill: "#BAD8DF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.1274 149.833H48.6817L47.8688 147.77C47.7967 147.587 47.5925 147.463 47.3624 147.463H44.7603C44.4781 147.463 44.2236 147.606 44.1162 147.824L43.1274 149.833Z",
    fill: "#BAD8DF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.2458 52.4169H48.2088C48.1227 51.4592 46.9012 50.6448 45.1832 50.2871C42.7959 50.4206 40.9307 51.315 40.8153 52.4169H40.0051L38.8694 53.7708H37.8533V54.9556H47.8501V53.7708H49.3238L48.2458 52.4169Z",
    fill: "#BAD8DF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.6558 55.3018H51.9136L49.5196 66.4036H42.4808L39.6558 55.3018Z",
    fill: "#F3F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.1401 52.6564C41.1401 52.6564 42.0739 50.9491 43.9174 51.0012C43.9174 51.0012 42.7443 51.8749 42.852 52.6564C42.9596 53.438 41.1401 52.6564 41.1401 52.6564Z",
    fill: "#F3F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.7398 53.7698H38.8694L40.0053 52.416H51.6615L52.7398 53.7698Z",
    fill: "#BAD8DF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.4697 55.6895H43.2789L44.0969 66.0564H43.2789L40.4697 55.6895Z",
    fill: "#E7EAEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.191 68.4679H194.066L194.076 68.3938L194.415 65.8805C194.427 65.7995 194.508 65.7383 194.606 65.7383C194.618 65.7383 194.629 65.7389 194.642 65.7402C194.705 65.7466 194.763 65.7695 194.808 65.804C194.862 65.8449 194.898 65.9015 194.905 65.966L195.191 68.4679Z",
    fill: "#BAD8DF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.174 67.8974L194.134 67.8983L194.415 65.8805C194.427 65.7995 194.508 65.7383 194.606 65.7383C194.618 65.7383 194.629 65.7389 194.642 65.7402C194.652 65.748 194.662 65.7554 194.671 65.7638C194.721 65.8086 194.75 65.8671 194.751 65.932L194.768 67.3828C194.771 67.661 194.507 67.8901 194.174 67.8974Z",
    fill: "#BAD8DF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.909 79.6514H193.738V159.881H195.909V79.6514Z",
    fill: "#BAD8DF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.74 79.6514H193.738V159.881H194.74V79.6514Z",
    fill: "#BAD8DF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.28 147.079H191.366V168.307H198.28V147.079Z",
    fill: "#BAD8DF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.487 147.079H191.366V168.307H195.487V147.079Z",
    fill: "#BAD8DF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.602 69.6789C198.602 70.6703 196.823 71.4738 194.629 71.4738C194.461 71.4738 194.297 71.4693 194.134 71.4596C192.174 71.3501 190.656 70.5944 190.656 69.6789C190.656 68.7634 192.174 68.0085 194.134 67.8988C194.297 67.8895 194.461 67.8848 194.629 67.8848C196.823 67.8848 198.602 68.6881 198.602 69.6789Z",
    fill: "#BAD8DF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.272 81.2345H191.359L188.921 71.4102H200.337L198.272 81.2345Z",
    fill: "#BAD8DF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.953 70.6689H188.304V71.6113H200.953V70.6689Z",
    fill: "#BAD8DF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.499 147.079H196.917L196.27 145.437C196.213 145.292 196.051 145.193 195.867 145.193H193.798C193.573 145.193 193.371 145.307 193.285 145.481L192.499 147.079Z",
    fill: "#BAD8DF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.57 69.5924H196.541C196.472 68.8306 195.501 68.1829 194.134 67.8984C192.235 68.0047 190.752 68.7161 190.66 69.5924H190.016L189.112 70.6693H188.304V71.6116H196.255V70.6693H197.428L196.57 69.5924Z",
    fill: "#BAD8DF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.738 71.8877H199.488L197.583 80.7182H191.985L189.738 71.8877Z",
    fill: "#F3F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.918 69.7831C190.918 69.7831 191.661 68.4253 193.127 68.4667C193.127 68.4667 192.194 69.1616 192.28 69.7831C192.365 70.4048 190.918 69.7831 190.918 69.7831Z",
    fill: "#F3F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.145 70.6687H189.112L190.016 69.5918H199.287L200.145 70.6687Z",
    fill: "#BAD8DF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.385 72.1982H192.62L193.27 80.4441H192.62L190.385 72.1982Z",
    fill: "#E7EAEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.428 137.154C176.655 136.444 176.78 135.675 176.78 134.871C176.78 131.284 174.306 128.376 171.254 128.376C170.806 128.376 170.372 128.44 169.955 128.558C169.458 118.849 164.395 111.217 158.221 111.217C152.341 111.217 147.469 118.14 146.589 127.187C142.215 129.682 139.216 134.789 139.216 140.684C139.216 143.494 139.899 146.125 141.086 148.38C137.026 150.48 134.441 153.648 134.441 157.191C134.441 163.515 142.674 168.641 152.829 168.641C160.431 168.641 166.955 165.768 169.756 161.671C170.534 161.826 171.339 161.908 172.162 161.908C179.073 161.908 184.676 156.196 184.676 149.151C184.676 143.632 181.239 138.933 176.428 137.154Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.428 137.155C176.428 137.155 164.253 133.175 154.972 140.188C145.691 147.201 139.236 136.14 142.333 131.001C140.388 133.624 139.217 137 139.217 140.684C139.217 143.495 139.899 146.126 141.086 148.38C137.027 150.481 134.441 153.648 134.441 157.191C134.441 163.515 142.674 168.641 152.829 168.641C158.531 168.641 164.299 169.236 168.009 167.805C171.079 166.62 174.488 166.196 177.813 166.698C179.721 166.986 181.363 167.217 181.691 167.217C188.602 167.217 184.676 156.197 184.676 149.151C184.676 143.633 181.239 138.933 176.428 137.155Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.281 135.356C216.402 126.683 211.529 120.046 205.649 120.046C199.475 120.046 194.412 127.362 193.916 136.67C193.499 136.557 193.065 136.496 192.617 136.496C189.565 136.496 187.091 139.283 187.091 142.722C187.091 143.493 187.216 144.23 187.443 144.911C182.632 146.616 179.195 151.121 179.195 156.411C179.195 163.165 184.797 168.64 191.709 168.64C197.252 168.64 201.953 165.118 203.597 160.238C205.762 161.848 208.386 162.791 211.214 162.791C218.637 162.791 224.654 156.3 224.654 148.294C224.654 142.643 221.656 137.747 217.281 135.356Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.552 141.958C202 140.538 200.136 152.008 200.136 152.008C185.268 146.328 179.21 157.034 179.21 157.034C179.542 163.499 185.011 168.641 191.709 168.641C195.074 168.641 198.129 167.342 200.378 165.23C202.617 163.127 205.972 162.126 209.275 162.641C209.908 162.74 210.555 162.791 211.214 162.791C215.674 162.791 219.626 160.447 222.071 156.84C222.155 156.613 226.995 143.366 214.552 141.958Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.104 155.301C174.966 159.391 158.409 168.775 139.088 161.64C119.767 154.506 96.5448 159.769 67.8053 167.481C39.0658 175.193 3.08855 161.312 -19.3786 161.279C-41.8458 161.247 -55.6785 169.895 -55.6785 169.895L226.969 169.364C214.705 151.117 198.158 149.012 184.104 155.301Z",
    fill: "url(#paint0_linear_2651_13823)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.234 153.39H178.514C176.209 153.39 174.341 156.391 174.341 160.094C174.341 163.797 176.209 166.799 178.514 166.799H180.234C182.539 166.799 184.408 163.797 184.408 160.094C184.408 156.391 182.539 153.39 180.234 153.39Z",
    fill: "#003940"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.366 162.612H152.261C149.86 162.612 147.877 160.785 147.744 158.451L143.587 91.4395H184.041L179.883 158.451C179.751 160.785 177.768 162.612 175.366 162.612Z",
    fill: "#E62225"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.957 162.612H158.852C156.45 162.612 154.335 162.261 154.335 158.451L150.177 91.4395H190.631L186.473 158.451C186.474 162.612 184.359 162.612 181.957 162.612Z",
    fill: "#F64C4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.367 86.4033H144.308C142.838 86.4033 141.646 87.5638 141.646 88.9953V91.4269H185.03V88.9953C185.03 87.5638 183.838 86.4033 182.367 86.4033Z",
    fill: "#003940"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.275 86.4033H152.216C150.746 86.4033 149.554 87.5638 149.554 88.9953V91.4269H192.938V88.9953C192.938 87.5638 191.746 86.4033 190.275 86.4033Z",
    fill: "url(#paint1_linear_2651_13823)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.48 153.39H147.761C145.455 153.39 143.587 156.391 143.587 160.094C143.587 163.797 145.455 166.799 147.761 166.799H149.48C151.786 166.799 153.654 163.797 153.654 160.094C153.654 156.391 151.786 153.39 149.48 153.39Z",
    fill: "url(#paint2_linear_2651_13823)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.822 160.096C150.822 162.812 149.452 165.014 147.761 165.014C146.07 165.014 144.699 162.812 144.699 160.096C144.699 157.38 146.07 155.178 147.761 155.178C149.452 155.178 150.822 157.38 150.822 160.096Z",
    fill: "#003940"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.624 147.766C165.624 146.781 165.862 146.016 166.339 145.47C166.816 144.925 167.514 144.652 168.434 144.652C169.354 144.652 170.056 144.925 170.541 145.47C171.026 146.016 171.269 146.781 171.269 147.766V149.72H174.066C174.158 149.72 174.237 149.752 174.304 149.817C174.371 149.883 174.405 149.96 174.405 150.049V151.039C174.405 151.128 174.371 151.205 174.304 151.271C174.237 151.336 174.158 151.368 174.066 151.368H165.963C165.871 151.368 165.791 151.336 165.724 151.271C165.657 151.205 165.624 151.128 165.624 151.039V147.766ZM169.7 149.72V147.827C169.7 147.363 169.606 146.993 169.418 146.716C169.23 146.439 168.902 146.301 168.434 146.301C167.966 146.301 167.642 146.439 167.462 146.716C167.282 146.993 167.192 147.363 167.192 147.827V149.72H169.7Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.837 137.643C172.837 137.554 172.87 137.477 172.937 137.411C173.004 137.346 173.083 137.313 173.175 137.313H174.066C174.158 137.313 174.237 137.346 174.304 137.411C174.371 137.477 174.405 137.554 174.405 137.643V142.992C174.405 143.081 174.371 143.158 174.304 143.224C174.237 143.289 174.158 143.321 174.066 143.321H165.963C165.871 143.321 165.791 143.289 165.724 143.224C165.657 143.158 165.624 143.081 165.624 142.992V142.003C165.624 141.913 165.657 141.836 165.724 141.771C165.791 141.705 165.871 141.673 165.963 141.673H172.837V137.643Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.624 132.124C165.624 131.994 165.66 131.897 165.731 131.831C165.802 131.766 165.908 131.709 166.05 131.66L173.978 128.668C174.003 128.661 174.032 128.656 174.066 128.656C174.158 128.656 174.237 128.689 174.304 128.754C174.371 128.819 174.404 128.896 174.404 128.986V129.865C174.404 130.028 174.369 130.142 174.298 130.207C174.227 130.272 174.158 130.317 174.091 130.341L172.699 130.867V134.725L174.091 135.25C174.158 135.274 174.227 135.319 174.298 135.384C174.369 135.45 174.404 135.564 174.404 135.727V136.606C174.404 136.695 174.371 136.773 174.304 136.838C174.237 136.903 174.158 136.935 174.066 136.935C174.032 136.935 174.003 136.931 173.978 136.923L166.05 133.931C165.908 133.882 165.802 133.826 165.731 133.76C165.66 133.695 165.624 133.598 165.624 133.467V132.124ZM171.13 131.452L167.556 132.796L171.13 134.139V131.452Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.498 124.724C165.498 124.178 165.574 123.698 165.724 123.283C165.875 122.868 166.063 122.522 166.288 122.245C166.514 121.968 166.763 121.759 167.035 121.616C167.306 121.474 167.564 121.394 167.806 121.378C167.906 121.37 167.988 121.4 168.051 121.47C168.113 121.539 168.145 121.618 168.145 121.708V122.562C168.145 122.701 168.118 122.805 168.063 122.874C168.009 122.943 167.936 123.006 167.844 123.063C167.635 123.185 167.453 123.371 167.298 123.619C167.144 123.867 167.066 124.236 167.066 124.724C167.066 124.936 167.089 125.137 167.135 125.329C167.181 125.52 167.248 125.687 167.336 125.829C167.423 125.972 167.53 126.084 167.655 126.165C167.781 126.246 167.923 126.287 168.082 126.287C168.274 126.287 168.431 126.248 168.552 126.171C168.674 126.094 168.778 125.963 168.866 125.78C168.954 125.597 169.035 125.355 169.11 125.054C169.186 124.753 169.273 124.378 169.374 123.93C169.483 123.442 169.61 123.021 169.757 122.666C169.903 122.312 170.079 122.023 170.283 121.799C170.488 121.576 170.724 121.409 170.992 121.299C171.26 121.189 171.565 121.134 171.908 121.134C172.284 121.134 172.633 121.215 172.955 121.378C173.277 121.541 173.553 121.773 173.783 122.074C174.013 122.375 174.195 122.746 174.329 123.185C174.462 123.625 174.529 124.118 174.529 124.663C174.529 125.119 174.473 125.554 174.36 125.969C174.247 126.384 174.084 126.753 173.871 127.074C173.658 127.396 173.4 127.654 173.099 127.85C172.798 128.045 172.464 128.155 172.096 128.179C171.996 128.188 171.914 128.157 171.852 128.088C171.789 128.019 171.757 127.94 171.757 127.85V126.995C171.757 126.857 171.782 126.751 171.833 126.677C171.883 126.604 171.958 126.543 172.058 126.495C172.167 126.438 172.276 126.368 172.384 126.287C172.493 126.205 172.589 126.096 172.673 125.957C172.756 125.819 172.825 125.646 172.88 125.438C172.934 125.231 172.961 124.972 172.961 124.663C172.961 124.418 172.942 124.183 172.905 123.954C172.867 123.727 172.804 123.527 172.717 123.356C172.629 123.185 172.52 123.047 172.391 122.941C172.261 122.835 172.1 122.782 171.908 122.782C171.724 122.782 171.573 122.839 171.456 122.953C171.339 123.067 171.239 123.24 171.155 123.472C171.071 123.704 170.992 123.991 170.917 124.333C170.841 124.675 170.745 125.07 170.628 125.518C170.528 125.925 170.409 126.281 170.271 126.586C170.133 126.891 169.963 127.143 169.763 127.343C169.562 127.543 169.326 127.691 169.054 127.789C168.782 127.887 168.458 127.935 168.082 127.935C167.705 127.935 167.358 127.854 167.041 127.691C166.723 127.528 166.451 127.304 166.225 127.019C166 126.735 165.822 126.395 165.692 126C165.563 125.605 165.498 125.179 165.498 124.724Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.624 114.136C165.624 114.047 165.657 113.97 165.724 113.904C165.791 113.839 165.871 113.807 165.963 113.807H166.853C166.945 113.807 167.025 113.839 167.092 113.904C167.159 113.97 167.192 114.047 167.192 114.136V116.334H174.066C174.158 116.334 174.237 116.367 174.304 116.432C174.371 116.497 174.405 116.575 174.405 116.664V117.653C174.405 117.743 174.371 117.82 174.304 117.885C174.237 117.95 174.158 117.983 174.066 117.983H167.192V120.181C167.192 120.27 167.159 120.348 167.092 120.413C167.025 120.478 166.945 120.51 166.853 120.51H165.963C165.871 120.51 165.791 120.478 165.724 120.413C165.657 120.348 165.624 120.27 165.624 120.181V114.136Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.404 112.256C174.404 112.345 174.371 112.422 174.304 112.488C174.237 112.553 174.158 112.585 174.065 112.585H165.962C165.87 112.585 165.791 112.553 165.724 112.488C165.657 112.422 165.624 112.345 165.624 112.256V111.267C165.624 111.177 165.657 111.1 165.724 111.034C165.791 110.969 165.87 110.937 165.962 110.937H174.065C174.158 110.937 174.237 110.969 174.304 111.034C174.371 111.1 174.404 111.177 174.404 111.267V112.256Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.62 103.783C171.511 103.767 171.43 103.724 171.375 103.654C171.321 103.586 171.294 103.51 171.294 103.428V102.439C171.294 102.35 171.325 102.271 171.388 102.201C171.45 102.132 171.532 102.102 171.632 102.11C171.975 102.134 172.318 102.218 172.661 102.36C173.004 102.503 173.313 102.72 173.589 103.013C173.865 103.307 174.091 103.677 174.267 104.125C174.442 104.573 174.53 105.114 174.53 105.749C174.53 106.31 174.444 106.807 174.273 107.238C174.102 107.67 173.863 108.036 173.558 108.337C173.253 108.639 172.887 108.873 172.46 109.04C172.034 109.206 171.57 109.306 171.068 109.339C170.75 109.355 170.399 109.363 170.014 109.363C169.63 109.363 169.278 109.355 168.961 109.339C168.459 109.306 167.995 109.206 167.568 109.04C167.142 108.873 166.776 108.639 166.471 108.337C166.165 108.037 165.927 107.67 165.756 107.238C165.584 106.807 165.499 106.31 165.499 105.749C165.499 105.114 165.586 104.573 165.762 104.125C165.937 103.677 166.163 103.307 166.439 103.013C166.715 102.72 167.027 102.503 167.374 102.36C167.721 102.218 168.062 102.134 168.396 102.11C168.496 102.102 168.578 102.132 168.64 102.201C168.703 102.271 168.735 102.35 168.735 102.439V103.428C168.735 103.51 168.708 103.587 168.653 103.66C168.599 103.734 168.517 103.779 168.409 103.795C168.241 103.819 168.078 103.876 167.919 103.966C167.76 104.055 167.618 104.178 167.493 104.332C167.367 104.487 167.265 104.682 167.186 104.918C167.106 105.154 167.067 105.431 167.067 105.749C167.067 106.066 167.117 106.343 167.217 106.579C167.317 106.815 167.451 107.012 167.619 107.171C167.786 107.33 167.987 107.452 168.221 107.538C168.455 107.623 168.701 107.674 168.961 107.691C169.278 107.707 169.63 107.715 170.014 107.715C170.399 107.715 170.75 107.707 171.068 107.691C171.336 107.674 171.585 107.623 171.814 107.538C172.044 107.452 172.243 107.33 172.41 107.171C172.578 107.013 172.711 106.816 172.811 106.579C172.912 106.343 172.962 106.066 172.962 105.749C172.962 105.431 172.922 105.155 172.843 104.918C172.764 104.682 172.661 104.485 172.536 104.326C172.41 104.167 172.268 104.043 172.109 103.953C171.95 103.864 171.787 103.807 171.62 103.783Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.279 154.36H133.559C131.254 154.36 129.385 157.362 129.385 161.065C129.385 164.768 131.254 167.77 133.559 167.77H135.279C137.584 167.77 139.452 164.768 139.452 161.065C139.452 157.362 137.584 154.36 135.279 154.36Z",
    fill: "#003940"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.412 163.583H107.306C104.905 163.583 102.922 161.756 102.789 159.422L98.6318 92.4102H139.086L134.929 159.422C134.796 161.756 132.813 163.583 130.412 163.583Z",
    fill: "#0C9D61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.002 163.583H113.897C111.495 163.583 109.38 163.232 109.38 159.422L105.222 92.4102H145.677L141.519 159.422C141.519 163.583 139.403 163.583 137.002 163.583Z",
    fill: "#47B881"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.412 87.374H99.353C97.8826 87.374 96.6904 88.5345 96.6904 89.966V92.3976H140.075V89.966C140.075 88.5345 138.883 87.374 137.412 87.374Z",
    fill: "#003940"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.32 87.374H107.261C105.791 87.374 104.598 88.5345 104.598 89.966V92.3976H147.983V89.966C147.983 88.5345 146.791 87.374 145.32 87.374Z",
    fill: "url(#paint3_linear_2651_13823)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.526 154.36H102.806C100.501 154.36 98.6321 157.362 98.6321 161.065C98.6321 164.768 100.501 167.77 102.806 167.77H104.526C106.83 167.77 108.699 164.768 108.699 161.065C108.699 157.362 106.83 154.36 104.526 154.36Z",
    fill: "url(#paint4_linear_2651_13823)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.806 165.985C104.497 165.985 105.868 163.783 105.868 161.067C105.868 158.35 104.497 156.148 102.806 156.148C101.115 156.148 99.7439 158.35 99.7439 161.067C99.7439 163.783 101.115 165.985 102.806 165.985Z",
    fill: "#003940"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.504 153.487C123.036 153.463 122.595 153.375 122.181 153.224C121.767 153.074 121.408 152.852 121.102 152.559C120.797 152.266 120.555 151.9 120.375 151.46C120.195 151.02 120.105 150.5 120.105 149.897C120.105 149.303 120.193 148.786 120.368 148.346C120.544 147.906 120.786 147.54 121.096 147.247C121.405 146.954 121.765 146.73 122.175 146.575C122.584 146.421 123.028 146.331 123.504 146.307C123.663 146.298 123.839 146.293 124.031 146.288C124.224 146.284 124.422 146.282 124.627 146.282C124.832 146.282 125.031 146.284 125.223 146.288C125.415 146.293 125.591 146.298 125.75 146.307C126.218 146.331 126.659 146.419 127.073 146.569C127.487 146.72 127.846 146.942 128.152 147.235C128.457 147.528 128.697 147.896 128.873 148.34C129.048 148.784 129.136 149.303 129.136 149.897C129.136 150.499 129.048 151.02 128.873 151.46C128.697 151.899 128.457 152.266 128.152 152.559C127.846 152.852 127.487 153.074 127.073 153.224C126.659 153.375 126.218 153.462 125.75 153.487C125.591 153.495 125.415 153.501 125.223 153.505C125.031 153.509 124.832 153.511 124.627 153.511C124.422 153.511 124.224 153.509 124.031 153.505C123.839 153.502 123.663 153.495 123.504 153.487ZM123.567 147.956C122.965 147.988 122.499 148.178 122.169 148.523C121.838 148.87 121.673 149.327 121.673 149.897C121.673 150.467 121.838 150.925 122.169 151.271C122.499 151.617 122.965 151.806 123.567 151.839C123.885 151.855 124.238 151.863 124.627 151.863C125.016 151.863 125.369 151.855 125.687 151.839C126.289 151.806 126.753 151.617 127.079 151.271C127.405 150.925 127.569 150.467 127.569 149.897C127.569 149.327 127.405 148.87 127.079 148.523C126.753 148.178 126.289 147.988 125.687 147.956C125.369 147.939 125.016 147.931 124.627 147.931C124.238 147.931 123.885 147.939 123.567 147.956Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.231 141.216C120.231 140.199 120.473 139.425 120.958 138.896C121.443 138.367 122.117 138.102 122.978 138.102C123.588 138.102 124.109 138.239 124.539 138.511C124.97 138.784 125.29 139.185 125.499 139.714L128.597 138.029C128.647 138.005 128.693 137.992 128.735 137.992C128.81 137.992 128.875 138.019 128.929 138.072C128.984 138.125 129.011 138.188 129.011 138.261V139.299C129.011 139.462 128.971 139.582 128.892 139.659C128.812 139.737 128.739 139.791 128.672 139.824L125.75 141.424V143.047H128.672C128.765 143.047 128.844 143.08 128.911 143.145C128.978 143.211 129.011 143.288 129.011 143.377V144.366C129.011 144.456 128.978 144.533 128.911 144.598C128.844 144.664 128.765 144.696 128.672 144.696H120.569C120.477 144.696 120.398 144.664 120.331 144.598C120.264 144.533 120.23 144.456 120.23 144.366L120.231 141.216ZM124.182 143.048V141.277C124.182 140.813 124.098 140.443 123.931 140.166C123.764 139.889 123.446 139.751 122.978 139.751C122.51 139.751 122.196 139.889 122.037 140.166C121.878 140.443 121.799 140.813 121.799 141.277V143.048H124.182Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.479 136.819C122.977 136.803 122.52 136.713 122.105 136.55C121.692 136.387 121.336 136.151 121.039 135.842C120.742 135.532 120.512 135.152 120.349 134.7C120.186 134.248 120.105 133.721 120.105 133.119C120.105 132.41 120.199 131.826 120.387 131.366C120.575 130.907 120.801 130.54 121.064 130.267C121.328 129.995 121.6 129.803 121.88 129.693C122.16 129.583 122.396 129.52 122.589 129.504C122.689 129.496 122.77 129.526 122.833 129.596C122.896 129.665 122.927 129.744 122.927 129.833V130.823C122.927 130.912 122.904 130.984 122.858 131.036C122.812 131.089 122.764 131.128 122.714 131.152C122.681 131.169 122.607 131.212 122.495 131.281C122.382 131.35 122.265 131.46 122.143 131.61C122.022 131.761 121.913 131.958 121.817 132.203C121.721 132.447 121.673 132.752 121.673 133.119C121.673 133.729 121.842 134.217 122.181 134.584C122.52 134.95 122.973 135.146 123.542 135.17C123.86 135.186 124.2 135.194 124.564 135.194C124.928 135.194 125.269 135.186 125.587 135.17C126.281 135.146 126.784 134.95 127.098 134.584C127.412 134.217 127.569 133.729 127.569 133.119C127.569 132.817 127.535 132.541 127.468 132.288C127.401 132.036 127.292 131.818 127.142 131.635C126.992 131.452 126.793 131.309 126.546 131.207C126.3 131.106 125.996 131.055 125.637 131.055H125.536V132.545C125.536 132.634 125.503 132.711 125.436 132.776C125.369 132.842 125.29 132.874 125.198 132.874H124.307C124.215 132.874 124.136 132.842 124.069 132.776C124.002 132.711 123.968 132.634 123.968 132.545V129.736C123.968 129.646 124.002 129.569 124.069 129.504C124.136 129.439 124.215 129.406 124.307 129.406H125.687C126.188 129.406 126.651 129.484 127.073 129.638C127.495 129.793 127.859 130.025 128.164 130.334C128.47 130.644 128.708 131.03 128.879 131.494C129.051 131.958 129.137 132.5 129.137 133.119C129.137 133.737 129.053 134.275 128.885 134.73C128.718 135.186 128.484 135.565 128.183 135.866C127.882 136.167 127.52 136.397 127.098 136.556C126.676 136.715 126.214 136.802 125.712 136.819C125.553 136.827 125.378 136.833 125.185 136.837C124.993 136.841 124.796 136.843 124.596 136.843C124.395 136.843 124.198 136.841 124.006 136.837C123.814 136.833 123.638 136.827 123.479 136.819Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.23 124.011C120.23 123.881 120.266 123.783 120.337 123.718C120.408 123.653 120.515 123.596 120.657 123.547L128.584 120.555C128.609 120.547 128.639 120.543 128.672 120.543C128.764 120.543 128.844 120.575 128.91 120.641C128.978 120.706 129.011 120.783 129.011 120.873V121.752C129.011 121.915 128.975 122.029 128.904 122.094C128.833 122.159 128.764 122.204 128.697 122.228L127.305 122.753V126.612L128.697 127.137C128.765 127.161 128.833 127.206 128.904 127.271C128.975 127.337 129.011 127.45 129.011 127.613V128.492C129.011 128.582 128.978 128.659 128.91 128.724C128.844 128.79 128.764 128.822 128.672 128.822C128.639 128.822 128.609 128.818 128.584 128.81L120.657 125.818C120.515 125.769 120.408 125.712 120.337 125.647C120.266 125.582 120.23 125.484 120.23 125.354V124.011ZM125.737 123.339L122.162 124.682L125.737 126.025V123.339Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.011 113.887C129.011 114.025 128.973 114.131 128.898 114.204C128.823 114.277 128.764 114.33 128.722 114.363L123.504 117.782H128.672C128.764 117.782 128.844 117.814 128.91 117.879C128.978 117.945 129.011 118.022 129.011 118.112V119.101C129.011 119.19 128.978 119.268 128.91 119.333C128.844 119.398 128.764 119.43 128.672 119.43H120.569C120.477 119.43 120.398 119.398 120.33 119.333C120.264 119.268 120.23 119.19 120.23 119.101V118.246C120.23 118.107 120.268 118.002 120.343 117.928C120.418 117.855 120.477 117.802 120.519 117.77L125.737 114.351H120.569C120.477 114.351 120.398 114.318 120.331 114.253C120.264 114.188 120.23 114.111 120.23 114.021V113.032C120.23 112.942 120.264 112.865 120.331 112.8C120.398 112.735 120.477 112.702 120.569 112.702H128.672C128.764 112.702 128.844 112.735 128.911 112.8C128.978 112.865 129.011 112.942 129.011 113.032V113.887Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.011 110.466C129.011 110.556 128.978 110.633 128.911 110.698C128.844 110.764 128.765 110.796 128.673 110.796H120.569C120.477 110.796 120.398 110.764 120.331 110.698C120.264 110.633 120.231 110.556 120.231 110.466V109.477C120.231 109.388 120.264 109.311 120.331 109.245C120.398 109.18 120.477 109.147 120.569 109.147H128.673C128.765 109.147 128.844 109.18 128.911 109.245C128.978 109.311 129.011 109.388 129.011 109.477V110.466Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.226 101.994C126.118 101.977 126.036 101.935 125.982 101.865C125.927 101.796 125.9 101.721 125.9 101.639V100.65C125.9 100.561 125.932 100.481 125.994 100.412C126.057 100.343 126.139 100.312 126.239 100.321C126.582 100.345 126.925 100.428 127.267 100.571C127.611 100.713 127.92 100.931 128.196 101.224C128.472 101.517 128.697 101.888 128.873 102.335C129.049 102.783 129.137 103.324 129.137 103.959C129.137 104.521 129.051 105.018 128.879 105.449C128.708 105.881 128.47 106.247 128.164 106.548C127.859 106.85 127.493 107.084 127.067 107.251C126.641 107.417 126.176 107.517 125.674 107.55C125.357 107.566 125.006 107.574 124.621 107.574C124.236 107.574 123.885 107.566 123.567 107.55C123.065 107.517 122.601 107.417 122.175 107.251C121.748 107.084 121.383 106.85 121.077 106.548C120.772 106.247 120.534 105.881 120.362 105.449C120.191 105.018 120.105 104.521 120.105 103.959C120.105 103.324 120.193 102.783 120.368 102.335C120.544 101.888 120.77 101.517 121.046 101.224C121.322 100.931 121.633 100.713 121.98 100.571C122.327 100.428 122.668 100.345 123.002 100.321C123.103 100.312 123.184 100.343 123.247 100.412C123.31 100.481 123.341 100.561 123.341 100.65V101.639C123.341 101.721 123.314 101.798 123.26 101.871C123.205 101.945 123.124 101.99 123.015 102.006C122.848 102.03 122.685 102.087 122.526 102.177C122.367 102.266 122.225 102.388 122.099 102.543C121.974 102.698 121.872 102.893 121.792 103.129C121.713 103.365 121.673 103.642 121.673 103.959C121.673 104.277 121.723 104.554 121.824 104.79C121.924 105.026 122.058 105.223 122.225 105.382C122.392 105.541 122.593 105.663 122.827 105.749C123.061 105.834 123.308 105.885 123.567 105.901C123.885 105.917 124.236 105.926 124.621 105.926C125.006 105.926 125.357 105.917 125.674 105.901C125.942 105.885 126.191 105.834 126.421 105.749C126.651 105.663 126.849 105.541 127.017 105.382C127.184 105.223 127.318 105.026 127.418 104.79C127.518 104.554 127.569 104.277 127.569 103.959C127.569 103.642 127.529 103.366 127.449 103.129C127.37 102.893 127.267 102.696 127.142 102.537C127.017 102.378 126.874 102.254 126.716 102.164C126.557 102.075 126.394 102.018 126.226 101.994Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.2338 155.331H88.514C86.209 155.331 84.3403 158.333 84.3403 162.036C84.3403 165.739 86.209 168.74 88.514 168.74H90.2338C92.539 168.74 94.4075 165.739 94.4075 162.036C94.4075 158.333 92.5387 155.331 90.2338 155.331Z",
    fill: "#003940"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.3666 164.554H62.2616C59.8597 164.554 57.8768 162.727 57.7445 160.392L53.5867 93.3809H94.041L89.8834 160.392C89.7514 162.727 87.7682 164.554 85.3666 164.554Z",
    fill: "#1F8297"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.9564 164.554H68.8511C66.4493 164.554 64.3341 164.202 64.3341 160.392L60.1763 93.3809H100.631L96.473 160.392C96.4734 164.554 94.358 164.554 91.9564 164.554Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.3669 88.3447H54.3078C52.8374 88.3447 51.6453 89.5052 51.6453 90.9367V93.3683H95.0295V90.9367C95.0295 89.5052 93.8374 88.3447 92.3669 88.3447Z",
    fill: "#003940"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.275 88.3447H62.2156C60.7451 88.3447 59.553 89.5052 59.553 90.9367V93.3683H102.937V90.9367C102.937 89.5052 101.745 88.3447 100.275 88.3447Z",
    fill: "url(#paint5_linear_2651_13823)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.4806 155.331H57.7608C55.4559 155.331 53.5872 158.333 53.5872 162.036C53.5872 165.739 55.4559 168.74 57.7608 168.74H59.4806C61.7858 168.74 63.6543 165.739 63.6543 162.036C63.6543 158.333 61.7856 155.331 59.4806 155.331Z",
    fill: "url(#paint6_linear_2651_13823)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.8219 162.038C60.8219 164.754 59.4512 166.956 57.76 166.956C56.069 166.956 54.6982 164.754 54.6982 162.038C54.6982 159.321 56.069 157.119 57.76 157.119C59.4512 157.119 60.8219 159.321 60.8219 162.038Z",
    fill: "#003940"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.0931 148.481C78.5914 148.464 78.1336 148.375 77.7195 148.212C77.3056 148.049 76.9502 147.813 76.6532 147.504C76.3565 147.195 76.1265 146.814 75.9632 146.362C75.8 145.91 75.7188 145.383 75.7188 144.781C75.7188 144.072 75.8128 143.488 76.0008 143.028C76.1891 142.568 76.4149 142.202 76.6783 141.929C76.9416 141.656 77.2136 141.465 77.4937 141.355C77.7738 141.245 78.0101 141.182 78.2025 141.166C78.3027 141.158 78.3842 141.188 78.447 141.258C78.5096 141.327 78.541 141.406 78.541 141.496V142.485C78.541 142.574 78.5182 142.645 78.4723 142.698C78.4264 142.752 78.3781 142.79 78.328 142.814C78.2948 142.831 78.2214 142.873 78.1085 142.942C77.9956 143.012 77.8785 143.122 77.7573 143.272C77.636 143.423 77.5273 143.62 77.4311 143.865C77.3351 144.109 77.287 144.414 77.287 144.781C77.287 145.391 77.4563 145.88 77.795 146.246C78.1338 146.612 78.5874 146.808 79.1561 146.832C79.4738 146.849 79.8145 146.856 80.1782 146.856C80.542 146.856 80.8829 146.849 81.2006 146.832C81.8947 146.808 82.3984 146.612 82.7121 146.246C83.0258 145.88 83.1826 145.391 83.1826 144.781C83.1826 144.48 83.1492 144.203 83.0822 143.95C83.0152 143.698 82.9065 143.48 82.756 143.297C82.6055 143.114 82.407 142.971 82.1603 142.869C81.9138 142.768 81.6105 142.717 81.2509 142.717H81.1505V144.206C81.1505 144.296 81.1173 144.373 81.0501 144.439C80.9831 144.504 80.9038 144.536 80.8117 144.536H79.921C79.8292 144.536 79.7499 144.504 79.6827 144.439C79.6159 144.373 79.5825 144.296 79.5825 144.206V141.398C79.5825 141.309 79.6159 141.231 79.6827 141.166C79.7499 141.101 79.8292 141.068 79.921 141.068H81.3009C81.8024 141.068 82.2648 141.146 82.687 141.3C83.1095 141.455 83.473 141.687 83.7784 141.996C84.0839 142.306 84.322 142.692 84.4934 143.156C84.6647 143.62 84.7506 144.162 84.7506 144.781C84.7506 145.399 84.6669 145.936 84.4995 146.392C84.3323 146.849 84.0982 147.227 83.7972 147.528C83.4961 147.829 83.1345 148.059 82.7123 148.218C82.2901 148.377 81.8279 148.464 81.326 148.481C81.1672 148.489 80.9919 148.495 80.7994 148.499C80.607 148.503 80.4104 148.505 80.2096 148.505C80.0091 148.505 79.8125 148.503 79.62 148.499C79.4278 148.495 79.2521 148.489 79.0931 148.481Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.057 133.852C83.057 133.763 83.0904 133.686 83.1574 133.62C83.2244 133.555 83.3037 133.522 83.3958 133.522H84.2863C84.3786 133.522 84.4579 133.555 84.5246 133.62C84.5919 133.686 84.625 133.763 84.625 133.852V139.201C84.625 139.29 84.5919 139.368 84.5246 139.433C84.4579 139.498 84.3786 139.531 84.2863 139.531H76.183C76.0912 139.531 76.0119 139.498 75.9447 139.433C75.8779 139.368 75.8445 139.29 75.8445 139.201V138.212C75.8445 138.122 75.8779 138.045 75.9447 137.98C76.0119 137.915 76.0912 137.882 76.183 137.882H83.057V133.852Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.8445 128.332C75.8445 128.202 75.8801 128.105 75.951 128.039C76.022 127.974 76.1287 127.917 76.2709 127.868L84.1984 124.876C84.2235 124.869 84.2529 124.864 84.2861 124.864C84.3783 124.864 84.4576 124.897 84.5244 124.962C84.5916 125.027 84.6248 125.104 84.6248 125.194V126.073C84.6248 126.236 84.5894 126.35 84.5183 126.415C84.4473 126.48 84.3783 126.525 84.3113 126.549L82.9191 127.075V130.933L84.3113 131.458C84.3786 131.482 84.4473 131.527 84.5183 131.592C84.5894 131.658 84.6248 131.772 84.6248 131.935V132.814C84.6248 132.903 84.5916 132.981 84.5244 133.045C84.4576 133.111 84.3783 133.143 84.2861 133.143C84.2529 133.143 84.2235 133.139 84.1984 133.131L76.2709 130.139C76.1287 130.09 76.022 130.034 75.951 129.968C75.8801 129.903 75.8445 129.806 75.8445 129.675V128.332ZM81.3511 127.661L77.7763 129.004L81.3511 130.347V127.661Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.7192 120.933C75.7192 120.387 75.7946 119.907 75.9449 119.492C76.0956 119.077 76.2836 118.731 76.5094 118.454C76.735 118.177 76.9841 117.968 77.2556 117.825C77.5273 117.683 77.7846 117.603 78.0271 117.587C78.1275 117.579 78.209 117.609 78.2716 117.679C78.3344 117.748 78.3658 117.827 78.3658 117.917V118.771C78.3658 118.91 78.3388 119.014 78.2843 119.083C78.23 119.152 78.1569 119.215 78.0646 119.272C77.8557 119.394 77.6741 119.58 77.5192 119.828C77.3646 120.076 77.287 120.445 77.287 120.933C77.287 121.144 77.3101 121.346 77.356 121.538C77.4019 121.729 77.4689 121.895 77.5565 122.038C77.6442 122.181 77.7512 122.293 77.8764 122.374C78.0018 122.455 78.1442 122.496 78.3028 122.496C78.4954 122.496 78.652 122.457 78.7733 122.38C78.8948 122.303 78.9991 122.172 79.087 121.989C79.1746 121.806 79.2563 121.564 79.3315 121.263C79.4066 120.962 79.4945 120.587 79.5948 120.139C79.7036 119.651 79.8312 119.23 79.9775 118.875C80.1238 118.521 80.2995 118.232 80.5041 118.008C80.7092 117.784 80.9453 117.618 81.2129 117.507C81.4807 117.398 81.7858 117.343 82.1287 117.343C82.505 117.343 82.8543 117.424 83.1761 117.587C83.4981 117.75 83.7742 117.982 84.0042 118.283C84.2342 118.584 84.4161 118.955 84.5497 119.394C84.6832 119.834 84.7504 120.327 84.7504 120.872C84.7504 121.328 84.694 121.763 84.5811 122.178C84.4682 122.593 84.3052 122.962 84.0919 123.283C83.8786 123.605 83.6213 123.863 83.3204 124.059C83.0192 124.254 82.6849 124.364 82.317 124.388C82.2166 124.397 82.1351 124.366 82.0725 124.297C82.0097 124.228 81.9782 124.149 81.9782 124.059V123.204C81.9782 123.066 82.0033 122.96 82.0536 122.886C82.1039 122.813 82.179 122.752 82.2792 122.704C82.3881 122.647 82.4969 122.577 82.6054 122.496C82.7141 122.414 82.8103 122.305 82.8938 122.166C82.9775 122.028 83.0462 121.855 83.1005 121.647C83.155 121.44 83.1822 121.181 83.1822 120.872C83.1822 120.627 83.1633 120.391 83.1256 120.163C83.088 119.936 83.0254 119.736 82.9375 119.565C82.8499 119.394 82.7411 119.256 82.6115 119.15C82.4819 119.044 82.3211 118.991 82.1287 118.991C81.9448 118.991 81.7944 119.048 81.6771 119.162C81.5598 119.276 81.4596 119.449 81.3759 119.681C81.2924 119.913 81.2129 120.2 81.1376 120.542C81.0624 120.884 80.9664 121.279 80.8491 121.727C80.749 122.134 80.6297 122.49 80.4917 122.795C80.3538 123.1 80.1844 123.352 79.9837 123.552C79.7829 123.751 79.5467 123.9 79.2748 123.998C79.0033 124.095 78.679 124.144 78.3025 124.144C77.9262 124.144 77.5794 124.063 77.2615 123.9C76.9439 123.737 76.672 123.513 76.4461 123.228C76.2205 122.944 76.0428 122.604 75.913 122.209C75.7841 121.814 75.7192 121.389 75.7192 120.933Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.719 113.021C75.719 112.475 75.7944 111.995 75.9446 111.58C76.0953 111.165 76.2833 110.819 76.5091 110.542C76.7347 110.265 76.9838 110.056 77.2554 109.913C77.5271 109.771 77.7843 109.692 78.0268 109.675C78.1272 109.667 78.2087 109.697 78.2713 109.766C78.3341 109.836 78.3656 109.915 78.3656 110.005V110.859C78.3656 110.998 78.3385 111.102 78.284 111.171C78.2298 111.24 78.1566 111.303 78.0644 111.36C77.8555 111.482 77.6738 111.668 77.519 111.916C77.3643 112.164 77.2868 112.533 77.2868 113.021C77.2868 113.233 77.3098 113.434 77.3557 113.625C77.4017 113.817 77.4686 113.984 77.5563 114.126C77.6439 114.268 77.7509 114.38 77.8761 114.462C78.0016 114.543 78.1439 114.584 78.3025 114.584C78.4952 114.584 78.6518 114.545 78.773 114.468C78.8945 114.391 78.9989 114.26 79.0867 114.077C79.1744 113.894 79.2561 113.652 79.3312 113.35C79.4066 113.05 79.4942 112.675 79.5946 112.227C79.7033 111.739 79.8309 111.318 79.9772 110.963C80.1235 110.609 80.2993 110.32 80.5038 110.096C80.709 109.872 80.9451 109.705 81.2127 109.596C81.4804 109.486 81.7856 109.431 82.1285 109.431C82.5048 109.431 82.854 109.513 83.1758 109.675C83.4979 109.838 83.774 110.07 84.004 110.371C84.234 110.672 84.4159 111.043 84.5494 111.482C84.683 111.922 84.7502 112.414 84.7502 112.96C84.7502 113.416 84.6937 113.851 84.5808 114.266C84.4679 114.681 84.3049 115.05 84.0916 115.371C83.8783 115.693 83.6211 115.952 83.3201 116.147C83.019 116.342 82.6846 116.452 82.3167 116.477C82.2163 116.485 82.1348 116.454 82.0722 116.385C82.0094 116.316 81.978 116.236 81.978 116.147V115.292C81.978 115.154 82.003 115.048 82.0533 114.975C82.1036 114.902 82.1788 114.84 82.2789 114.791C82.3879 114.735 82.4966 114.665 82.6051 114.584C82.7139 114.503 82.8101 114.393 82.8935 114.254C82.9772 114.116 83.046 113.943 83.1003 113.735C83.1547 113.527 83.182 113.269 83.182 112.96C83.182 112.715 83.1631 112.48 83.1253 112.251C83.0877 112.024 83.0251 111.824 82.9373 111.653C82.8496 111.482 82.7409 111.344 82.6113 111.238C82.4817 111.132 82.3209 111.079 82.1285 111.079C81.9446 111.079 81.7941 111.136 81.6768 111.25C81.5595 111.364 81.4594 111.537 81.3757 111.769C81.2922 112.001 81.2127 112.288 81.1373 112.63C81.0622 112.972 80.9662 113.367 80.8489 113.814C80.7487 114.222 80.6295 114.578 80.4915 114.883C80.3535 115.189 80.1842 115.441 79.9834 115.64C79.7826 115.84 79.5465 115.988 79.2745 116.086C79.003 116.183 78.6788 116.232 78.3023 116.232C77.926 116.232 77.5792 116.151 77.2613 115.988C76.9437 115.825 76.6717 115.601 76.4459 115.317C76.2203 115.032 76.0426 114.692 75.9128 114.297C75.7838 113.902 75.719 113.477 75.719 113.021Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.2653 156.303H43.5455C41.2405 156.303 39.3718 159.304 39.3718 163.007C39.3718 166.71 41.2405 169.712 43.5455 169.712H45.2653C47.5705 169.712 49.439 166.71 49.439 163.007C49.439 159.304 47.5705 156.303 45.2653 156.303Z",
    fill: "#003940"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.3979 165.526H17.2928C14.8912 165.526 12.908 163.698 12.7758 161.364L8.61816 94.3525H49.0727L44.9149 161.364C44.7826 163.698 42.7997 165.526 40.3979 165.526Z",
    fill: "#FFAD0D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.9877 165.526H23.8827C21.481 165.526 19.3657 165.174 19.3657 161.364L15.208 94.3525H55.6626L51.5047 161.364C51.5047 165.526 49.3895 165.526 46.9877 165.526Z",
    fill: "#FFDD82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.3979 89.3164H9.33885C7.8684 89.3164 6.67627 90.4769 6.67627 91.9084V94.34H50.0605V91.9084C50.0608 90.4769 48.8686 89.3164 47.3979 89.3164Z",
    fill: "#003940"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.3062 89.3164H17.2471C15.7766 89.3164 14.5845 90.4769 14.5845 91.9084V94.34H57.9687V91.9084C57.969 90.4769 56.7768 89.3164 55.3062 89.3164Z",
    fill: "url(#paint7_linear_2651_13823)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5114 156.303H12.7916C10.4866 156.303 8.61792 159.304 8.61792 163.007C8.61792 166.71 10.4866 169.712 12.7916 169.712H14.5114C16.8166 169.712 18.6851 166.71 18.6851 163.007C18.6851 159.304 16.8166 156.303 14.5114 156.303Z",
    fill: "url(#paint8_linear_2651_13823)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8532 163.009C15.8532 165.725 14.4825 167.928 12.7915 167.928C11.1005 167.928 9.72974 165.725 9.72974 163.009C9.72974 160.293 11.1005 158.091 12.7915 158.091C14.4825 158.091 15.8532 160.293 15.8532 163.009Z",
    fill: "#003940"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.436 144.475C30.436 143.49 30.6744 142.725 31.1511 142.18C31.6277 141.634 32.3261 141.361 33.2458 141.361C34.1655 141.361 34.8683 141.634 35.3531 142.18C35.8381 142.725 36.0808 143.49 36.0808 144.475V146.429H38.8778C38.9701 146.429 39.0494 146.461 39.1162 146.527C39.1834 146.592 39.2166 146.669 39.2166 146.759V147.748C39.2166 147.837 39.1834 147.915 39.1162 147.98C39.0494 148.045 38.9701 148.077 38.8778 148.077H30.7745C30.6827 148.077 30.6034 148.045 30.5362 147.98C30.4694 147.915 30.436 147.837 30.436 147.748V144.475ZM34.5126 146.429V144.536C34.5126 144.072 34.4186 143.702 34.2306 143.425C34.0423 143.148 33.7141 143.01 33.246 143.01C32.7777 143.01 32.4537 143.148 32.2738 143.425C32.0941 143.702 32.004 144.072 32.004 144.536V146.429H34.5126Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.436 136.526C30.436 136.395 30.4716 136.298 30.5426 136.232C30.6135 136.168 30.7203 136.11 30.8624 136.062L38.79 133.07C38.815 133.062 38.8445 133.058 38.8776 133.058C38.9699 133.058 39.0492 133.09 39.116 133.155C39.1832 133.221 39.2164 133.298 39.2164 133.387V134.266C39.2164 134.429 39.181 134.543 39.1098 134.608C39.0389 134.674 38.9699 134.719 38.9029 134.742L37.5106 135.268V139.126L38.9029 139.652C38.9701 139.676 39.0389 139.721 39.1098 139.786C39.181 139.851 39.2164 139.965 39.2164 140.128V141.007C39.2164 141.097 39.1832 141.174 39.116 141.239C39.0492 141.304 38.9699 141.337 38.8776 141.337C38.8445 141.337 38.815 141.333 38.79 141.324L30.8624 138.333C30.7203 138.284 30.6135 138.227 30.5426 138.162C30.4716 138.097 30.436 137.999 30.436 137.869V136.526ZM35.9427 135.854L32.3678 137.197L35.9427 138.54V135.854Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.436 128.342C30.436 127.357 30.6744 126.592 31.1511 126.047C31.6277 125.501 32.3261 125.229 33.2458 125.229C34.1655 125.229 34.8683 125.501 35.3531 126.047C35.8381 126.592 36.0808 127.357 36.0808 128.342V130.296H38.8778C38.9701 130.296 39.0494 130.329 39.1162 130.394C39.1834 130.459 39.2166 130.537 39.2166 130.626V131.615C39.2166 131.705 39.1834 131.782 39.1162 131.847C39.0494 131.912 38.9701 131.944 38.8778 131.944H30.7745C30.6827 131.944 30.6034 131.912 30.5362 131.847C30.4694 131.782 30.436 131.705 30.436 131.615V128.342ZM34.5126 130.296V128.403C34.5126 127.939 34.4186 127.569 34.2306 127.292C34.0423 127.016 33.7141 126.877 33.246 126.877C32.7777 126.877 32.4537 127.016 32.2738 127.292C32.0941 127.569 32.004 127.939 32.004 128.403V130.296H34.5126Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.6486 118.208C37.6486 118.119 37.682 118.042 37.749 117.977C37.816 117.911 37.8953 117.879 37.9873 117.879H38.8778C38.9701 117.879 39.0494 117.911 39.1162 117.977C39.1834 118.042 39.2166 118.119 39.2166 118.208V123.569C39.2166 123.659 39.1834 123.736 39.1162 123.801C39.0494 123.866 38.9701 123.899 38.8778 123.899H30.7745C30.6827 123.899 30.6034 123.866 30.5362 123.801C30.4694 123.736 30.436 123.659 30.436 123.569V118.306C30.436 118.217 30.4694 118.14 30.5362 118.074C30.6034 118.009 30.6827 117.977 30.7745 117.977H31.6653C31.7573 117.977 31.8366 118.009 31.9036 118.074C31.9706 118.14 32.004 118.217 32.004 118.306V122.25H33.9984V118.575C33.9984 118.485 34.0318 118.408 34.0988 118.343C34.1658 118.278 34.2451 118.245 34.3371 118.245H35.2276C35.3199 118.245 35.3992 118.278 35.466 118.343C35.5332 118.408 35.5664 118.485 35.5664 118.575V122.25H37.6486V118.208Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.436 112.885C30.436 111.867 30.6785 111.094 31.1635 110.565C31.6486 110.035 32.3218 109.771 33.1829 109.771C33.7934 109.771 34.314 109.907 34.7446 110.18C35.1753 110.453 35.4952 110.854 35.7041 111.383L38.8023 109.697C38.8526 109.673 38.8985 109.661 38.9404 109.661C39.0156 109.661 39.0806 109.687 39.1348 109.74C39.1893 109.794 39.2163 109.856 39.2163 109.93V110.968C39.2163 111.13 39.1766 111.25 39.0973 111.328C39.0177 111.405 38.9448 111.46 38.8776 111.493L35.9549 113.092V114.717H38.8776C38.9699 114.717 39.0492 114.749 39.1159 114.814C39.1831 114.88 39.2163 114.957 39.2163 115.046V116.035C39.2163 116.125 39.1831 116.202 39.1159 116.268C39.0492 116.333 38.9699 116.365 38.8776 116.365H30.7743C30.6825 116.365 30.6032 116.333 30.536 116.268C30.4692 116.202 30.4358 116.125 30.4358 116.035L30.436 112.885ZM34.3874 114.717V112.946C34.3874 112.482 34.3037 112.112 34.1363 111.835C33.9691 111.558 33.6515 111.42 33.1829 111.42C32.7148 111.42 32.4012 111.558 32.2423 111.835C32.0835 112.112 32.004 112.482 32.004 112.946V114.717H34.3874Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2651_13823",
    x1: 297.814,
    y1: 152.095,
    x2: 290.73,
    y2: 215.34,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2651_13823",
    x1: 203.812,
    y1: 86.4033,
    x2: 200.242,
    y2: 103.741,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2651_13823",
    x1: 156.177,
    y1: 153.39,
    x2: 138.893,
    y2: 160.686,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2651_13823",
    x1: 158.857,
    y1: 87.374,
    x2: 155.286,
    y2: 104.712,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2651_13823",
    x1: 111.222,
    y1: 154.36,
    x2: 93.9378,
    y2: 161.657,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2651_13823",
    x1: 113.811,
    y1: 88.3447,
    x2: 110.241,
    y2: 105.682,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2651_13823",
    x1: 66.1776,
    y1: 155.331,
    x2: 48.8929,
    y2: 162.628,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2651_13823",
    x1: 68.8428,
    y1: 89.3164,
    x2: 65.2725,
    y2: 106.654,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2651_13823",
    x1: 21.2083,
    y1: 156.303,
    x2: 3.92368,
    y2: 163.599,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2651_13823"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 195,
    height: 170,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaste1);
export default __webpack_public_path__ + "static/media/waste1.2811e3a81841af169bd4c48e59b13c39.svg";
export { ForwardRef as ReactComponent };